module.exports = __webpack_public_path__ + "media/images/global/breadcrumb/icon_home4x-05c764f8ba1a09d5bed76cfe3352dcd2.png";